import constants from 'core/constants';

export default function shouldAppendIncludingToday(
  dateId,
  dateType,
  includeTodayInToDates
) {
  if (!includeTodayInToDates || dateType !== constants.DATE_ONLY) {
    return false;
  }

  const toDateIds = [
    'yesterday',
    'weekToDate',
    'monthToDate',
    'quarterToDate',
    'yearToDate',
  ];
  return toDateIds.includes(dateId);
}
